import { MessagesService } from './../_services/messages.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
export class FormBase {
    protected keys= null;

    constructor (protected _messageService: MessagesService
           ) {
    }

    public getErrorsInputs(error, formGroup: FormGroup) {
        for (let key in formGroup.controls) {
            if (formGroup.controls.hasOwnProperty(key)) {
                const control: FormControl = <FormControl>formGroup.controls[key];
                if (control.status === 'INVALID') {
                    if (control.value) {
                        if (control instanceof FormControl) {
                            this._messageService.addError(control.errors, this.getFieldName(key));
                        };
                        const group: FormGroup = <FormGroup>formGroup.controls[key];
                        for (const key2 in group.controls) {
                            if (group.controls.hasOwnProperty(key2)) {
                                const controlbis: FormControl = <FormControl>group.controls[key2];
                                if (controlbis.status === 'INVALID') {
                                    this._messageService.addError(controlbis.errors, this.getFieldName(key2));
                                }
                            }
                        }
                    } else {
                        this._messageService.addError(control.errors, this.getFieldName(key));
                    }
                }
            }
        }
    }

    public getFieldName(key) {
        return this.keys[key];
    }
}